import { useTreeViewStyles } from 'components/WorkspaceEditor/styles'
import React, { forwardRef, memo, ReactNode } from 'react'

export interface TreeLayoutProps {
    children?: ReactNode
    classNames?: string
}

/**
 * Layout wrapper for <TreeView /> component,
 * also provides a ref to the container for dynamic sizing
 * @param {TreeLayoutProps} TreeLayoutProps - Component props
 * @returns {ReactElement} Rendered TreeLayout component
 */
export const TreeLayout = memo(
    forwardRef<HTMLDivElement, TreeLayoutProps>(
        ({ children, classNames }, ref) => {
            const classes = useTreeViewStyles()

            return (
                <div
                    data-testid="tree-layout"
                    ref={ref}
                    className={`${classes.treeContainer} ${classNames}`}
                    id="tree-layout-id"
                >
                    {children}
                </div>
            )
        }
    )
)
